<script setup lang="ts">
import { getEnvVar } from "@/utils";
import { onMounted, computed } from "vue";
import { useAppStore } from "@/stores/app";
import { useI18n } from "vue-i18n";

const { t, locale } = useI18n({ useScope: "global" });

const appStore = useAppStore();

const cdnBaseUrl = getEnvVar("VITE_VACV_COMMON_STATIC_URL");

const bienvenueMsg = computed(() => {
  return t("home.messages.welcome") + " " + appStore.appName + "!";
});

onMounted(() => {
  appStore.setAppName(t("common.labels.app-name"));
});
</script>

<template>
  <div class="home">
    <div class="acv-logo">
      <img
        :src="`${cdnBaseUrl}/img/acv-logo_${locale}.svg`"
        :alt="$t('common.labels.acv-logo')"
      />
    </div>
    <h1>{{ bienvenueMsg }}</h1>
    <h3>{{ $t("home.messages.dosearch") }}</h3>
  </div>
</template>

<style scoped lang="scss">
.acv-logo {
  img {
    height: 40px;
  }
}
</style>
